import { render, staticRenderFns } from "./Records.vue?vue&type=template&id=d61ab7f4&scoped=true&"
import script from "./Records.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Records.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d61ab7f4",
  null
  
)

export default component.exports